/* eslint-disable */
'use strict';
import Splide from '@splidejs/splide';

const ProductReviews = {
    init: function() {
        if (!window.location.pathname.includes('/products/')) {
            return;
        }

        //this.loadReviews();
    },


    /**
     * Load the reviews
     */
    loadReviews: function() {
        const reviews = window.reviews.reviews.filter(r => r.score > 4);
        const reviewsContainer = document.querySelector('.js-product-single__left-testimonials');
        const reviewsList = reviewsContainer.querySelector('ul');
        const sliderSelector = document.querySelector('.product-single__left-testimonials-slider');

        reviews.forEach((review) => {
            reviewsList.insertAdjacentHTML('beforeend', this.renderReview(review));
        });

        let main = new Splide(sliderSelector, {
            type: 'loop',
            perPage: 1,
            rewind: false,
            focus: 0,
            gap: 16,
            pagination: true,
            arrows: true,
        });
        main.mount();
    },


    /**
     * Render a single review - NOT BEING USED
     * @param {Object} review - The review object
     * 
     * @returns {string} - The HTML string
     */
    renderReview: function(review) {
        const stars = review.score;
        const content = review.content;
        const user = review.user;
        const userVerified = review.verifiedBuyer;
        let starsHTML = '';
        let verifiedHTML = '';

        for (let i = 0; i < 5; i++) {
            if (i < stars) {
                starsHTML += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288.1 0l86.5 164 182.7 31.6L428 328.5 454.4 512 288.1 430.2 121.7 512l26.4-183.5L18.9 195.6 201.5 164 288.1 0z"/></svg>';
            } else {
                starsHTML += '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1.04429L8.08596 3.95233L8.1996 4.16071L8.43289 4.20439L11.6887 4.81409L9.41306 7.22106L9.25001 7.39353L9.28055 7.6289L9.70679 10.9138L6.71442 9.49331L6.5 9.39153L6.28558 9.49331L3.29321 10.9138L3.71945 7.6289L3.75 7.39353L3.58694 7.22106L1.31131 4.81409L4.56711 4.20439L4.8004 4.16071L4.91404 3.95233L6.5 1.04429Z" stroke="#322E22"/></svg>';
            }
        }

        userVerified ? verifiedHTML = '<span class="product-single__left-testimonial-badge">Verified Buyer</span>' : '';

        return `
        <li class="splide__slide product-single__left-testimonial">
            <div class="product-single__left-testimonial-inner">
                <div class="hero-homepage__box-stars">
                    <div class="hero-homepage__box-stars-icons">
                        ${starsHTML}
                    </div>
                    <p class="product-single__left-testimonial-desc">“${content}"</p>
                    <div class="product-single__left-testimonial-wrap">
                        <span class="product-single__left-testimonial-name">${user.displayName}</span>
                        ${verifiedHTML}
                    </div>
                </div>
            </div>
        </li>
        `;
    }
};

export default ProductReviews;